import {Component, EventEmitter, HostBinding, Input, OnInit, Output, signal} from '@angular/core';
import {Settings} from '../../settings.class';
import {LocalStorage} from '../../storage.class';
import {User} from '../../classes/user.class';
import {ConfirmDialogService} from '../../services/confirm-dialog-service/confirm-dialog.service';
import {RepairComment} from '../../classes/repaircomment.class';
import {RepairService} from '../../services/repair.service';
import {DatePipe} from "@angular/common";
import {MatButton, MatIconButton} from "@angular/material/button";
import {MatIcon} from "@angular/material/icon";
import {MatFormField, MatInput, MatLabel} from "@angular/material/input";
import {CdkTextareaAutosize} from "@angular/cdk/text-field";
import {Nl2brPipe} from "../../pipes/nl2br.pipe";
import {SafeBgUrlPipe} from "../../pipes/safe-bg-url.pipe";
import {FormsModule} from "@angular/forms";

@Component({
    selector: 'app-repair-comment',
    templateUrl: './repair-comment.component.html',
    styleUrls: ['./repair-comment.component.scss'],
    imports: [
        DatePipe,
        MatIconButton,
        MatIcon,
        MatFormField,
        MatLabel,
        CdkTextareaAutosize,
        MatInput,
        Nl2brPipe,
        SafeBgUrlPipe,
        MatButton,
        FormsModule
    ]
})
export class RepairCommentComponent implements OnInit {

    @HostBinding('class.logitem') readonly logitem = signal<boolean>(false);

    @Input() repairComment: RepairComment;

    @Output() uploadFiles = new EventEmitter<File[]>();

    @Output() deleted = new EventEmitter<RepairComment>();

    @Output() placedComment = new EventEmitter<RepairComment>();

    @Output() openFile = new EventEmitter<object>();

    url = Settings.API_ENDPOINT + 'file/';
    token = LocalStorage.getUserToken();

    readonly editing = signal<boolean>(false);

    readonly mayEdit = signal<boolean>(false);

    private user: User;

    constructor(
        private repairService: RepairService,
        private confirmDialog: ConfirmDialogService
    ) {
    }

    ngOnInit(): void {
        this.logitem.set(this.repairComment.statuslog);
        this.user = LocalStorage.getUser();
        this.editing.set(!this.repairComment.id);
        this.mayEdit.set(this.user.id === this.repairComment.user_id || !this.repairComment.user_id);
    }

    placeOrEditComment() {
        if (this.repairComment.comment === '' || this.repairComment.comment === undefined) {
            return;
        }
        this.repairService.saveComment(this.repairComment).then(comment => {
            if (!this.repairComment.id) {
                this.repairComment.id = comment.id;
                this.repairComment.created_at = comment.created_at;
                this.placedComment.emit(this.repairComment);
            }
            this.editing.set(false);
        });
    }

    edit() {
        this.editing.set(true);
    }

    public uploadFile(event) {
        const files = event.srcElement.files;
        this.uploadFiles.emit(files);
    }

    deleteComment() {
        this.confirmDialog.confirm(
            'Verwijderen',
            `Weet u zeker dat u deze reactie van ${this.repairComment?.user?.name} wilt verwijderen?`,
            'Verwijderen',
            'Behouden'
        ).then(() => {
            if (this.repairComment.id) {
                this.repairService.deleteComment(this.repairComment.id).then(success => {
                    if (success) {
                        this.deleted.emit(this.repairComment);
                    }
                });
            } else {
                this.deleted.emit(this.repairComment);
            }
        }, () => {
        });
    }

}
